<style scoped>
.copy-btn {
  margin-top: -7px;
  margin-right: -11px;
  height: 38px !important;

  font-family: Lato;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  letter-spacing: 0.342857px;
  color: #333333;
}
.negative-margin {
  margin-top: -12px;
  display: block;
}
.social-media-share-btn {
  width: 100%;
  text-align: left;
  padding: 5px 10px;
  font-family: Lato;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 19px;
  color: #ffffff;
  border-radius: 3px;
}
.bg-facebook {
  background-color: #3b5998;
  vertical-align: bottom;
}
.bg-whatsapp {
  background-color: #25d366;
  vertical-align: bottom;
}
.bg-pinterest {
  background-color: #e60023;
  vertical-align: bottom;
}
.bg-email {
  background-color: #848484;
  vertical-align: bottom;
}

.share-link-label {
  font-family: Lato;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  color: rgba(0, 0, 0, 0.87);
}
</style>

<template>
  <v-dialog :value="value" persistent max-width="400">
    <v-card style="overflow-x:hidden">
      <v-icon class="float-right ma-3" @click="$emit('input', false)">
        {{ mdiWindowClose }}
      </v-icon>
      <p class="dialog-title px-5 ml-1 py-5">
        {{ $t("SHOW_THIS_DESIGN_TO_FRIENDS_N_FAMILY") }}
      </p>

      <v-card-text>
        <span class="share-link-label">{{ $t("SHARE_VIA_LINK") }} </span>

        <v-text-field
          id="link_to_copy"
          v-model="shareableLink"
          outlined
          dense
          readonly
          color="grey "
          class="mt-5"
          filled
          style="background:#fff"
        >
          <!-- disabled -->
          <template v-slot:append class="cursor-pointer">
            <v-btn
              width="100"
              class="copy-btn"
              color="rgba(0, 0, 0, 0.06)"
              depressed
              @click="copyurl"
            >
              <img src="../../assets/others/content-copy.svg" alt="" />
              {{ Copy_btn_text }}
            </v-btn>
          </template>
        </v-text-field>
        <div class="my-5">
          <div class="border-t"></div>
          <div class="text-center negative-margin">
            <span class="bg-white px-3 text--disabled">or</span>
          </div>
        </div>

        <v-row>
          <v-col cols="12" md="6" class="py-2 px-2">
            <button
              type="button"
              class="social-media-share-btn bg-whatsapp"
              @click="shareWhatsapp"
            >
              <v-icon size="18px" color="white">{{ mdiWhatsapp }}</v-icon>
              {{ $t("SHARE_ON_WHATSAPP") }}
            </button>
          </v-col>
          <v-col cols="12" md="6" class="py-2 px-2">
            <button
              type="button"
              class="social-media-share-btn bg-email"
              @click="shareEmail"
            >
              <v-icon size="18px" color="white">{{ mdiEmail }}</v-icon>
              {{ $t("SHARE_VIA_EMAIL") }}
            </button>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import {
  mdiEmail,
  mdiPinterest,
  mdiWhatsapp,
  mdiFacebook,
  mdiWindowClose,
  mdiContentCopy
} from "@mdi/js";

export default {
  props: {
    value: { type: Boolean, required: true },
    shareableLink: { type: String, required: true },
    cardId: { type: String, required: true }
  },

  data() {
    return {
      mdiEmail,
      mdiPinterest,
      mdiWhatsapp,
      mdiFacebook,
      mdiWindowClose,
      mdiContentCopy,
      Copy_btn_text: ""
    };
  },

  mounted() {
    this.Copy_btn_text = this.$t("COPY");
  },

  methods: {
    shareWhatsapp() {
      let link = "https://api.whatsapp.com/send?text=";
      link += "Checkout this weddingcard on WedNicely " + this.shareableLink;
      document.location.href = link;
    },

    shareEmail() {
      let link = "mailto:?to=&subject=Checkout My Invitation Card&body=";
      link += "Checkout this weddingcard on WedNicely " + this.shareableLink;
      document.location.href = link;
    },

    copyurl() {
      let testingCodeToCopy = document.querySelector("#link_to_copy");
      testingCodeToCopy.setAttribute("type", "text");
      testingCodeToCopy.select();
      try {
        var successful = document.execCommand("copy");
        if (successful) {
          this.Copy_btn_text = this.$t("COPIED");
          setTimeout(() => {
            this.Copy_btn_text = this.$t("COPY");
          }, 1500);
          // this.showSnakeBar("success",this.$t('URL_COPIED)
        } else this.showSnakeBar("error", "Session Expired");
      } catch (err) {
        this.showSnakeBar("error", "Oops, unable to copy");
      }
    }
  }
};
</script>
